import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { GlobalConstants } from 'src/app/common/global';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class MapService {
  private mapOpenSubject = new BehaviorSubject<boolean>(false);
  isMapOpen$ = this.mapOpenSubject.asObservable();
  membersByCounties: any[] | null = null;

  constructor(private http: HttpClient) { }

  toggleMap(showMap: boolean) {
    this.mapOpenSubject.next(showMap);
  }

  getMembersByCounties(): Observable<any> {
    if(this.membersByCounties) {
      return of(this.membersByCounties)
    } else {
      return this.http.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/getMembersByCounty`).pipe(
        tap((data: any) => this.membersByCounties = data)
      );
    }
  }
}
